import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IUsers } from "./routeType";
import { useGetAllUser } from "./getAll";
import { useGetUser } from "./get";

import { useGetAllMembers } from "@/api/members/getAll";

const { getPath } = getApi("users.deactivate.post");

type IExtractedRouteType = IUsers["userSingleDeactivate"];

export type IDeactivateUsers = IPickMutation<IExtractedRouteType>;

const deactivateUser: MutationFunction<
  IDeactivateUsers["response"],
  IDeactivateUsers["variables"]
> = ({ userId, ...params }) => {
  return axiosClient.post(getPath({ userId }), { params });
};

export const useDeactivateUser = createMutation({
  mutationFn: deactivateUser,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetAllMembers.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetUser.getKey({ userId }),
    });
  },
});
